import React from "react";
import "./PrizeRedeemed.scss";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ReactComponent as Arrow } from "./../../../assets/svg/arrow.svg";
import DogCat from "../../../assets/images/dog&cat.png";
import DefaultLayout from "../../components/Layouts/DefaultLayout";

function PrizeRedeemed() {
  const { t } = useTranslation();

  return (
    <DefaultLayout>
      <section className="prize-redeemed">
        <div className="container">
          <img src={DogCat} alt="Dog and Cat" className="award" />
          <h1>{t("prize-redeemed-title")}</h1>
          <p>{t("prize-redeemed-text")}</p>
          <Link to="/home" className="row">
            <Arrow />
            <span>{t("go-back-home")}</span>
          </Link>
        </div>
      </section>
    </DefaultLayout>
  );
}

export default PrizeRedeemed;
